import { Mutex } from "@utils/helpers/Mutex";
import { checkTokenExpiry } from "./jwt";
import { getSavedToken, refreshToken } from "./authHelper";
import { store } from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";

const tokenMutex = new Mutex();

export default async function getAccessTokenForHeader(): Promise<string> {
  return await tokenMutex.dispatch(async () => {
    try {
      const tokens = await getSavedToken();

      if (!!tokens?.token && checkTokenExpiry(tokens)) {
        return tokens.token;
      } else {
        if (!!tokens?.refreshToken && !!tokens?.token) {
          const payload = await refreshToken({
            refreshToken: tokens.refreshToken,
            token: tokens.token,
          });

          if (payload?.token) return payload.token;
        }
      }
    } catch (error) {
      console.log("getAccessTokenForHeader error", error);
    }

    await store.dispatch(AuthActions.logoutAsync());
    throw new Error("Invalid Token For Header");
  });
}
